// Role constants matching backend ADMIN_ROLES and QUESTSOL_ROLES
export const ADMIN_ROLES = ['super_admin', 'global_admin', 'questsol_admin', 'client_admin'];
export const QUESTSOL_ROLES = ['super_admin', 'global_admin', 'questsol_admin'];

export const isAdmin = (role) => ADMIN_ROLES.includes(role);
export const isQuestsolAdmin = (role) => QUESTSOL_ROLES.includes(role);
export const canSwitchOrg = (role) => ['super_admin', 'global_admin', 'questsol_admin'].includes(role);
export const isSuperAdmin = (role) => role === 'super_admin';
// Hours spent are internal to QuestSol: only these roles see them anywhere.
export const canSeeHours = (role) => ['super_admin', 'questsol_admin'].includes(role);
// Who gets the Organisations screen: the roles the API lets list and create organisations.
export const canSeeOrganisations = (role) => ['super_admin', 'questsol_admin'].includes(role);

// Human-readable role labels
export const ROLE_LABELS = {
  super_admin: 'Super Admin',
  global_admin: 'Global Admin',
  client_admin: 'Client Admin',
  questsol_admin: 'QuestSol Admin',
  editor: 'Editor',
  creator: 'Creator',
  global_viewer: 'Client Viewer',
};

export const getRoleLabel = (role, orgName) => {
  if (role === 'client_admin' && orgName) return `${orgName} Admin`;
  return ROLE_LABELS[role] || role;
};
